module.exports = __webpack_public_path__ + "img/partner_02.67434d9f.jpg";